import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-vrijstellingen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-vrijstellingen.component.html',
  styleUrl: './tekst-vrijstellingen.component.scss',
})
export class TekstVrijstellingenComponent {}
